import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import LaunchTeaser from './components/LaunchTeaser';
import EmailCapture from './components/EmailCapture';
import Footer from './components/Footer';
import Admin from './pages/Admin';

function HomePage({ scrollY }) {
  return (
    <>
      <Hero scrollY={scrollY} />
      <Philosophy />
      <LaunchTeaser />
      <EmailCapture />
      <Footer />
    </>
  );
}

function App() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Router>
      <div 
        className="min-h-screen bg-slate-950 text-slate-100"
        data-component-path="client/src/App.jsx"
        data-component-line="1:7"
        data-component-id="client/src/App.jsx:1:7"
      >
        <Toaster 
          position="bottom-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#f1f5f9',
              border: '1px solid #334155',
            },
          }}
        />
        
        <Routes>
          <Route path="/" element={<HomePage scrollY={scrollY} />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;